import {Component} from "@angular/core";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {CompanyDetailsEntityModel} from "../../company-details-entity.model";

@Component({
    selector: "wbo-company-details-edit-details",
    templateUrl: "./company-details-edit-details.component.html"
})
export class CompanyDetailsEditDetailsComponent {

    constructor(public model: CompanyDetailsEntityModel, public editService: EditService) {
    }
}
